var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6875 38.5H8.3125C3.72163 38.5 0 34.7784 0 30.1875V8.8125C0 4.22163 3.72163 0.5 8.3125 0.5H29.6875C34.2784 0.5 38 4.22163 38 8.8125V30.1875C38 34.7784 34.2784 38.5 29.6875 38.5Z",
    fill: "#41479B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 30.1867V28.3619L32.1056 24.5H38V22.5H22V38.5H24V26.3623L36.6863 34.674C37.1357 33.9745 37.4825 33.203 37.7068 32.381",
    fill: "#F5F5F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.558941 33.1891C0.76141 33.7116 1.01479 34.2088 1.3136 34.674L14 26.3623V38.5H15.9999V22.5H0V24.5H5.89438L0 28.3619V30.1875C0 30.5071 0.0187031 30.8223 0.0538086 31.1325",
    fill: "#F5F5F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.09505V10.6381L5.89438 14.5H0V16.5H16V0.5H14V12.6377L1.3136 4.32598C0.820562 5.09362 0.45073 5.9478 0.231117 6.86055",
    fill: "#F5F5F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4301 5.78207C37.2295 5.27004 36.9797 4.78264 36.6863 4.3259L24 12.6377V0.5H22V16.5H38V14.5H32.1056L38 10.6381V8.8125C38 8.48148 37.98 8.15507 37.9424 7.83415",
    fill: "#F5F5F5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22 0.5H16V16.5H0V22.5H16V38.5H22V22.5H38V16.5H22V0.5Z",
    fill: "#FF4B55"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2715 24.5L0.053833 31.1325C0.135028 31.8497 0.307216 32.5392 0.55904 33.1891L13.9451 24.5H10.2715V24.5Z",
    fill: "#FF4B55"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5658 24.5L37.7069 32.381C37.8976 31.6821 38 30.9468 38 30.1875V30.1867L29.2393 24.5L25.5658 24.5Z",
    fill: "#FF4B55"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.5L0.231117 6.86053C0.0803789 7.48664 0 8.14014 0 8.81249V9.09504L8.32645 14.5H12Z",
    fill: "#FF4B55"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6735 14.5L37.9424 7.83417C37.8584 7.1184 37.684 6.43039 37.4301 5.78217L24 14.5H27.6735Z",
    fill: "#FF4B55"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUk);
export default __webpack_public_path__ + "static/media/uk.e1753c54.svg";
export { ForwardRef as ReactComponent };